import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from '@mui/material'
import { FC } from 'react'
import { DropdownOption } from 'shared/models/dropdownOption'
import { fontSize } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

interface ToggleEditSelectFieldProps {
    edit: boolean
    disabled?: boolean
    label: string
    labelId: string
    dropdownData: DropdownOption[]
    // selectedDropdownData: DropdownOption | undefined
    selectedDropdownData: DropdownOption | undefined
    onChange: (e: SelectChangeEvent<string>, child) => void
}

const ToggleEditSelectField: FC<ToggleEditSelectFieldProps> = ({
    edit,
    disabled,
    label,
    labelId,
    dropdownData,
    selectedDropdownData,
    onChange,
}) => {
    if (edit)
        return (
            <FormControl fullWidth>
                <InputLabel id={`${labelId}_label`}>{label}</InputLabel>
                <Select
                    fullWidth
                    id={labelId}
                    labelId={`${labelId}_label`}
                    label={label}
                    onChange={onChange}
                    style={{ marginBottom: getPxAsRem(16) }}
                    value={selectedDropdownData?.id.toString()}
                    disabled={disabled}
                    inputProps={{
                        sx: {
                            padding: `${getPxAsRem(16, 65, 16, 12)} !important`,
                        },
                    }}
                >
                    {dropdownData.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )

    return (
        <>
            <InputLabel sx={{ fontSize: fontSize.xsmall }}>{label}</InputLabel>
            <Typography variant="body1">
                {selectedDropdownData?.value}
            </Typography>
        </>
    )
}

export default ToggleEditSelectField
